import { TableHeaderPosition } from "../types";

interface IProps {
  cellIdx: number;
  tableHasHeader: boolean;
  tableHeaderPosition: TableHeaderPosition;
  tableCols: number;
  tableRows: number;
}

export const isTableCellHeader = ({
  cellIdx,
  tableHasHeader,
  tableHeaderPosition,
  tableCols,
  tableRows,
}: IProps) => {
  if (!tableHasHeader) return false;
  const col = cellIdx % tableCols;
  const row = Math.floor(cellIdx / tableCols);

  switch (tableHeaderPosition) {
    case TableHeaderPosition.Top:
      return row === 0;
    case TableHeaderPosition.Bottom:
      return row === tableRows - 1;
    case TableHeaderPosition.Left:
      return col === 0;
    case TableHeaderPosition.Right:
      return col === tableCols - 1;
    default:
      return false;
  }
};
